// extracted by mini-css-extract-plugin
module.exports = {"DropDown":"DropDown_DropDown__3SUtr","Alt":"DropDown_Alt__XE0iA"};